// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import { createSelector } from "reselect"

import RESULTS_VIEW_TYPES from "../../consts/resultViewTypes"
import Options from "../../records/Options"

export default function OptionsReducer(state = new Options(), action) {
  switch (action.type) {
    case "SET_CUSTOMER_VERIFIED":
      return state.set("customerVerified", true)
    case "SET_CURRENCY":
      return state.set("currency", action.currency)

    case "SET_CURRENCY_SUCCESS":
      return state.set("currency", action.currency)

    case "SET_OPTION":
      return state.set(action.option, action.value)

    case "TOGGLE_OPTION":
      if (action.option === "preferredResultsView") {
        return state.set(
          action.option,
          state.get(action.option) === RESULTS_VIEW_TYPES.AUTO
            ? RESULTS_VIEW_TYPES.LIST
            : RESULTS_VIEW_TYPES.AUTO,
        )
      }
      return state.set(action.option, !state.get(action.option))

    default:
      return state
  }
}

export const getOptions = (state) => state.options

export const getLocationsApiUrl = createSelector(getOptions, (state) => state.locationsApiUrl)

export const getLanguage = createSelector(getOptions, (state) => state.language)

export const getCountry = createSelector(getOptions, (state) => state.country)

export const getApiUrl = createSelector(getOptions, (state) => state.apiUrl)

export const getBookingApiUrl = createSelector(getOptions, (state) => state.bookingApiUrl)

export const getPICIApiUrl = createSelector(getOptions, (state) => state.piciApiUrl)

export const getMMBPICIApiUrl = createSelector(getOptions, (state) => state.mmbPiciApiUrl)

export const getCurrency = createSelector(getOptions, (state) => state.currency)

export const getAffiliateThisSession = createSelector(
  getOptions,
  (state) => state.affiliateThisSession,
)

export const getRawAffilId = createSelector(getOptions, (state) => state.affiliate)

export const getBranding = createSelector(getOptions, (state) => state.branding)

export const getBrandingAffilId = createSelector(getBranding, (state) => state.get("affilid"))

export const getEnableHiddenFeatures = createSelector(
  getOptions,
  (state) => state.enableHiddenFeatures,
)

export const getApiKey = createSelector(getOptions, (state) => state.apiKey)

export const getBookedAt = createSelector(
  getOptions,
  (state) => state.get("bookedAt") || state.getIn(["branding", "booked_at"]),
)

export const getBookedAtScrooge = createSelector(getOptions, (state) => state.bookedAtScrooge)

export const accountGraphqlApiSelector = createSelector(
  getOptions,
  (state) => state.accountGraphqlApi,
)

export const getCsSupportEnabled = createSelector(getBranding, (branding) =>
  branding.getIn(["services", "cs_support", "banner", "enabled"], false),
)
